var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('osdi-icon-button',_vm._g(_vm._b({attrs:{"icon":"mdi-close"}},'osdi-icon-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v(" "+_vm._s(_vm.$t("smartcollege.closeButton"))+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }